import Glide, { Controls, Autoplay, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

console.log( 'Glide loaded' );

/**
 * Hero Slider
 */
 ( () => {
    const blocks = document.querySelectorAll( '.home .hero-banner' )

    if ( !blocks.length ) {
        return
    }

    function initGallery( block ) {
        const glideEl = block.querySelector( '.glide' )
        if (!glideEl) {
            return
        }
        const infiniteLoop = glideEl.dataset.infiniteLoop === 'true'

        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel', 
            autoplay: 6000,
            perView: 1,
            gap: 16
        })

        glide.mount({ Controls, Autoplay })

        if ( !infiniteLoop ) {
            glide.on( 'move.after', () => {
                glideEl.querySelector( '.glide__arrow--left' ).disabled = glide.index === 0
                glideEl.querySelector( '.glide__arrow--right' ).disabled = glide.index === glideEl.querySelectorAll( '.glide__slide:not(.glide__slide--clone)' )?.length - 1
            })
        }
    }
    blocks.forEach( initGallery )
})();

/**
 * Image Gallery Flexi Block
 */
( () => {
    const blocks = document.querySelectorAll( '.block--gallery-slider' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glideEl = block.querySelector( '.glide' )
        const infiniteLoop = glideEl.dataset.infiniteLoop === 'true'

        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel',
            autoplay: 10000,
            perView: 3,
            gap: 30,
            peek: 150,
            breakpoints: {
                800: {
                    perView: 1,
                    gap: 20,
                    peek: 50
                }
            }
        })

        glide.mount({ Controls, Autoplay, Breakpoints })

        if ( !infiniteLoop ) {
            glide.on( 'move.after', () => {
                glideEl.querySelector( '.glide__arrow--left' ).disabled = glide.index === 0
                glideEl.querySelector( '.glide__arrow--right' ).disabled = glide.index === glideEl.querySelectorAll( '.glide__slide:not(.glide__slide--clone)' )?.length - 1
            })
        }
    }
    blocks.forEach( initGallery )
})();

/**
 * Single Gallery
 * 
 * Display a modoal for images.
 */
;( () => {
    const modal = document.querySelector( '#image-modal' )
    let images = document.querySelectorAll( '.image-gallery a' )
    let isMounted = false

    if ( !images.length || !modal ) {
        return
    }

    const imageCarousel = new Glide( modal.querySelector( '.glide' ), {
        type: 'carousel',
        perView: 1
    })

    images.forEach( ( image, index ) => {
        image.addEventListener( 'click', event => {
            event.preventDefault()

            showGalleryModal()

            if ( !isMounted ) {
                imageCarousel.mount({ Controls, Swipe })
                isMounted = true
            }

            imageCarousel.go( `=${ index }` )
        })
    })

    modal.addEventListener( 'click', event => {
        event.preventDefault()

        if ( ![ 'IMG', 'BUTTON', 'svg' ].includes( event.target.tagName ) ) {
            hideGalleryModal()
        }
    })


    function showGalleryModal() {
        modal.classList.add( 'is-visible' )
        modal.setAttribute( 'aria-hidden', false )

        window.addEventListener( 'keyup', escHideModal )
    }

    function hideGalleryModal() {
        modal.classList.remove( 'is-visible' )
        modal.setAttribute( 'aria-hidden', true )

        window.removeEventListener( 'keyup', escHideModal )
    }

    /**
     * Hide the modal by pressing the escape key.
     * 
     * @param {KeyboardEvent} event 
     */
     function escHideModal( event ) {
        if ( event.key === 'Escape' ) {
            hideGalleryModal()
        }
    }
})();